import styled from 'styled-components'

import Cosplay1 from '~/shared/assets/images/cosplay-1.png'
import Cosplay2 from '~/shared/assets/images/cosplay-2.png'
import Cosplay3 from '~/shared/assets/images/cosplay-3.png'
import Cosplay4 from '~/shared/assets/images/cosplay-4.png'
import CosplayLarge from '~/shared/assets/images/cosplay-large.png'
import theme from '~/shared/styles/theme'

function Cosplay() {
  return (
    <Wrapper>
      <Title>코스플레이</Title>
      <Desc>
        만화나 애니메이션, 게임 속의 캐릭터로 분장하여 표현하는 또 다른 자아,
        코스플레이. ‘일러스타 페스’는 대규모의 탈의실, 물품 보관소, 지원센터
        등의 편의 시설을 통해 코스플레이어들이 자유롭게 꿈과 끼를 펼칠 수 있는
        장을 마련하는 데에 최선을 다하고 있습니다.
      </Desc>
      <ImageGrid>
        <Image src={Cosplay1} alt="Cosplay 1" />
        <Image src={Cosplay2} alt="Cosplay 2" />
        <Image className="large" src={CosplayLarge} alt="Cosplay Large" />
        <Image src={Cosplay3} alt="Cosplay 3" />
        <Image src={Cosplay4} alt="Cosplay 4" />
      </ImageGrid>
    </Wrapper>
  )
}

export default Cosplay

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 36px;

  height: auto;
  padding: 36px 24px;

  background-color: white;
  border: 1px solid #c1c3c2;
  border-radius: 12px;
`

const Title = styled.h2`
  font-family: NanumSquareNeo-Bold, sans-serif;
  font-size: 32px;
  font-weight: 500;
`

const Desc = styled.p`
  font-size: 18px;
  line-height: 1.4;
  color: #313634;
`

const ImageGrid = styled.div`
  display: grid;
  grid-auto-rows: 238px;
  grid-template-columns: 356px 356px 292px;
  gap: 14px 12px;

  @media ${theme.device.medium} {
    grid-auto-rows: 207px;
    grid-template-columns: 1fr;
    grid-template-rows: repeat(5, auto);
    gap: 20px;

    & > .large {
      grid-column: 1;
      grid-row: auto;
      order: 5;
    }
  }
`

const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
  border-radius: 12px;

  &.large {
    grid-row: span 2;

    @media ${theme.device.medium} {
      grid-row: auto;
      order: 5;
      width: 100%;
      height: auto;
    }
  }
`
